import { Component, Prop } from 'vue-property-decorator';
import * as tsx from 'vue-tsx-support';

import './style.less';

const title = ['您确定要恢复出厂设置吗?','您确定要重启该云手机吗?','您确定要退出吗？']

interface IRestoreAndRestart {
  type?: number
}

@Component
export default class RestoreAndRestart extends tsx.Component<IRestoreAndRestart> {
  
  @Prop() public type?: number
  
  render() {
    return (
      <div class='restoreAndRestart-container'>
        <div class='title'>
          {this.$slots.default || title[this.$props.type]}
        </div>
      </div>
    )
  }
  
}